import { useMutation, type UseMutationOptions } from '@tanstack/react-query';
import { type CustomerPairingRatingDetail, StatusCode } from '@hungryroot/rest';
import { postApiV2CustomersCustomerIdPairingRatings } from '@hungryroot/rest/api/v2/customers/[id]/pairing_ratings/post';
import { type PairingPayload } from './usePatchCustomerPairingRatings';

type UsePostCustomerPairingRatingsProps<Context> = Omit<
  UseMutationOptions<
    CustomerPairingRatingDetail,
    Error,
    { customerId: number; payload: PairingPayload },
    Context
  >,
  'mutationFn'
>;

export function usePostCustomerPairingRatings<Context>(
  props?: UsePostCustomerPairingRatingsProps<Context>
) {
  return useMutation({
    mutationFn: async (params: {
      customerId: number;
      payload: PairingPayload;
    }) => {
      const { customerId, payload } = params;
      const res = await postApiV2CustomersCustomerIdPairingRatings(
        customerId,
        payload
      );
      if (res.status !== StatusCode.SuccessCreated) {
        throw new Error(JSON.stringify(res.data, null, 2));
      }
      return res.data;
    },
    ...props,
  });
}
